import Model from "../Model";

class ComercialZone extends Model{

    buildUrl ({ param }) {
        return ['zoneview/getbyzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialZone;